import { useSelector } from '@/api/state';
import useLogout from '@/hooks/auth/useLogout';
import {
  Avatar,
  Button,
  FloatingTooltip,
  Tooltip,
  TooltipCore,
  Text,
} from '@payaca/ambrosia';
import UntitledIcon from '@payaca/untitled-icons';
import React, { FC } from 'react';

const UserLogoutSection: FC = () => {
  const myProfile = useSelector((state: any) => state.users.myProfile);
  const logout = useLogout();

  return (
    <div className="flex w-full items-center pt-4 pb-2 border-t">
      <Avatar
        placeholderInitials={`${myProfile.firstname[0]}${myProfile.lastname[0]}`}
        imgSrc={myProfile.avatarUrl}
      />
      <div className="ml-3 w-0 flex-1 whitespace-nowrap transition-opacity">
        <Text truncate>
          {myProfile.firstname} {myProfile.lastname}
        </Text>
        <Tooltip tooltipContent={myProfile.email} className="!block">
          <Text as="div" level="supporting" colour="primary" truncate>
            {myProfile.email}
          </Text>
        </Tooltip>
      </div>
      <div className="text-base">
        <FloatingTooltip>
          <Button
            className="!inline-flex"
            aria-label={'Log out'}
            size={'xs'}
            variant="quaternary"
            onClick={logout}
          >
            <UntitledIcon className="h-4 w-4" name="log-out-03.3" />
          </Button>

          <TooltipCore>Log out</TooltipCore>
        </FloatingTooltip>
      </div>
    </div>
  );
};

export default UserLogoutSection;
